"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultTemplate = exports.getTemplateList = exports.getTemplatesIsLoaded = exports.getTemplatesIsLoading = exports.getTemplatesState = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var _templates = require("./templates.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTemplatesState = R.path(['createGift', 'templates']);
exports.getTemplatesState = getTemplatesState;
var getTemplatesIsLoading = R.pipe(getTemplatesState, function (state) {
  return state.isLoading;
});
exports.getTemplatesIsLoading = getTemplatesIsLoading;
var getTemplatesIsLoaded = R.pipe(getTemplatesState, function (state) {
  return state.isLoaded;
});
exports.getTemplatesIsLoaded = getTemplatesIsLoaded;
var getTemplateList = (0, _reselect.createSelector)(R.path(['createGift', 'templates', 'templates']), function (templateList) {
  var hasBlankTemplate = templateList.length && templateList.some(function (template) {
    return template.type === 'sample';
  });

  if (hasBlankTemplate) {
    return templateList;
  }

  var blankTemplate = _objectSpread({}, _templates.defaultBlankTemplate);

  return templateList.length ? [].concat((0, _toConsumableArray2.default)(templateList), [blankTemplate]) : [blankTemplate];
});
exports.getTemplateList = getTemplateList;
var getDefaultTemplate = (0, _reselect.createSelector)(R.path(['createGift', 'templates', 'templates']), R.find(R.prop('is_default')));
exports.getDefaultTemplate = getDefaultTemplate;